/**
 * 广告相关接口
 */
import request from './request'

/**
 * 获取广告内容
 * @param {object} params - { positionKey }
 * @returns {Promise}
 */
export function getAds(params) {
  return request.post('/api/ad/getAds', params)
}
